module.exports = __webpack_public_path__ + "static/media/rentals.5e7e47dd.jpg";